import { MarketView, Markets } from '../../models/markets';
import { find } from 'lodash';
import {
  SELECTED_MARKET_CHANGED,
  MARKETS_LOAD_REQUESTED,
  MARKETS_LOAD_SUCCESS,
  MARKETS_LOAD_FAILURE
} from './actions';
import { RESET_DATA } from '../actions';
import { PayloadAction } from '@ipreo/muni-shared';

//tslint:disable:no-null-keyword
export interface MarketsState {
  markets: Markets;
  selected: MarketView;
  loading: boolean;
  error?: string;
}

export const marketDefaultState: MarketsState = {
  markets: [],
  selected: null,
  loading: false
};

const DEFAULT_MARKET_SYMBOL = 'SPY';

export function marketsReducer(
  state = marketDefaultState,
  action: PayloadAction<Markets | MarketView | string>
): MarketsState {
  switch (action.type) {
    case SELECTED_MARKET_CHANGED:
      return {
        ...state,
        selected: (action as PayloadAction<MarketView>).payload
      };
    case MARKETS_LOAD_REQUESTED:
      return {
        ...state,
        loading: true
      };
    case MARKETS_LOAD_SUCCESS:
      return {
        ...state,
        markets: (action as PayloadAction<Markets>).payload,
        selected: determineSelected(
          state.selected,
          (action as PayloadAction<Markets>).payload
        ),
        loading: false
      };
    case MARKETS_LOAD_FAILURE:
      return {
        ...marketDefaultState,
        error: (action as PayloadAction<string>).payload,
        loading: false
      };
    case RESET_DATA:
      return marketDefaultState;
    default:
      return state;
  }
}

function determineSelected(
  selected: MarketView | null,
  markets: Markets
): MarketView | null {
  if (markets && markets.length) {
    let currentSelection: MarketView;
    if (selected) {
      currentSelection = find(
        markets,
        market => market.symbol === selected.symbol
      );
    }
    return (
      currentSelection ||
      find(markets, market => market.symbol === DEFAULT_MARKET_SYMBOL) ||
      markets[0]
    );
  } else {
    return null;
  }
}

export const getMarkets = (state: MarketsState) => state.markets;
export const getSelected = (state: MarketsState) => state.selected;
export const getLoading = (state: MarketsState) => state.loading;
